function staggerVariants(delay = 0.05, yOffset = 10) {
  return {
    container: {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: { staggerChildren: delay },
      },
    },
    item: {
      hidden: { opacity: 0, y: yOffset },
      visible: { opacity: 1, y: 0 },
    },
  }
}

export const defaultStagger = staggerVariants()

export const expandCollapse = {
  initial: { height: 0, opacity: 0 },
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
  transition: { duration: 0.2 },
}

// Direction-aware screen transition based on tab index
export function slideDirection(direction: 'left' | 'right' | 'up' | 'down') {
  const offsets = {
    left:  { x: -60, y: 0 },
    right: { x: 60, y: 0 },
    up:    { x: 0, y: 60 },
    down:  { x: 0, y: -60 },
  }
  return {
    initial: { opacity: 0, ...offsets[direction] },
    animate: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 0, x: -offsets[direction].x, y: -offsets[direction].y },
    transition: { duration: 0.25, ease: [0.4, 0, 0.2, 1] as const },
  }
}

// Stagger for suggestion chips
export function chipStagger() {
  return {
    container: {
      hidden: {},
      visible: { transition: { staggerChildren: 0.05 } },
    },
    item: {
      hidden: { opacity: 0, x: -10, scale: 0.95 },
      visible: { opacity: 1, x: 0, scale: 1 },
    },
  }
}
